module.exports = __webpack_public_path__ + "static/img/04.1b890b13.png";